<template>
  <img :src="currentSrc" @error="onError" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { cloudinary as cld } from "../classes/cloudinary";
import Honeybadger from "honeybadger-js";
// TODO: THIS IS TEMPORARY CODE - THIS SHOULDN'T WORK LIKE THAT!
// There was a problem with using some assets through cloudinary
// Problem showed up suddenly on production after rails upgrades
// we uploaded a new image and something changed along the way in a way how images are uploaded or stored or read
// It's need to be investigated, if not it will stay like that until the redesign happens
const REPORTED_CLOUDINARY_FAILURES = new Set();
let REPORTED_COUNT = 0;
const MAX_REPORTS_PER_PAGE = 3;

export default {
  name: "CloudinaryImg",
  inheritAttrs: false,
  props: {
    src: { type: String, required: true },
    transforms: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      originalSrc: this.src,
      currentSrc: this.buildSrc(this.src, this.transforms),
      lastCloudinarySrc: null
    };
  },
  watch: {
    src(newVal) {
      this.originalSrc = newVal;
      this.currentSrc = this.buildSrc(newVal, this.transforms);
    },
    transforms: {
      handler(newVal) {
        this.currentSrc = this.buildSrc(this.src, newVal);
      },
      deep: true
    }
  },
  methods: {
    buildSrc(src, transforms) {
      const gon = (typeof window !== "undefined" && window.gon) ? window.gon : {};
      if (gon && gon.development) {
        this.lastCloudinarySrc = null;
        return src;
      }

      try {
        const url = cld(src, transforms || {});
        this.lastCloudinarySrc = url;
        return url;
      } catch (e) {
        this.lastCloudinarySrc = null;
        return src;
      }
    },
    onError(e) {
      const img = e.target;
      const failingUrl = this.currentSrc;
      const wasCloudinary = !!this.lastCloudinarySrc && failingUrl === this.lastCloudinarySrc;

      img.onerror = null;
      this.currentSrc = this.originalSrc;
      this.lastCloudinarySrc = null;

      // Notify Honeybadger only when Cloudinary URL failed and not in dev
      // const gon = (typeof window !== "undefined" && window.gon) ? window.gon : {};
      // const shouldReportEnv = !(gon && gon.development);

      // if (
      //   wasCloudinary &&
      //   shouldReportEnv &&
      //   !REPORTED_CLOUDINARY_FAILURES.has(failingUrl) &&
      //   REPORTED_COUNT < MAX_REPORTS_PER_PAGE
      // ) {
      //   REPORTED_CLOUDINARY_FAILURES.add(failingUrl);
      //   REPORTED_COUNT += 1;
      //
      //   Honeybadger.notify("Cloudinary asset fetch failed; fell back to compiled asset", {
      //     name: "CloudinaryAssetError",
      //     component: "CloudinaryImg",
      //     action: "img.onerror",
      //     tags: ["cloudinary", "asset", "fallback"],
      //     context: {
      //       failingUrl,
      //       originalSrc: this.originalSrc,
      //       transforms: this.transforms,
      //       location: typeof window !== "undefined" && window.location ? window.location.href : null,
      //       referrer: typeof document !== "undefined" ? document.referrer : null,
      //       userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      //       online: typeof navigator !== "undefined" ? navigator.onLine : null,
      //       gonEnv: { development: !!(gon && gon.development), debug: !!(gon && gon.debug) }
      //     }
      //   });
      // }
    }
  }
};
</script>
